
<script>
  import ExtraiDadosBasico from "../../Componentes/ExtracaoDados/ExtraiDadosBasico.svelte";
  import ExibeItem from "../../Classes/exibeItem.js";
  import BotaoInserir from "../../componentes_basicos/BotaoInserir.svelte";
    import Pesquisa from "../../Componentes/ExtracaoDados/Pesquisa.svelte";
    import Constantes from "../../Classes/Constantes";
    import { permissaoUsuario } from "../../Classes/Stores";

    
  
 
  let termo_pesquisa;
  let componente;
  let camponente_pesquisar="";
  const api = "consultas.php";
  const parametros = {
   
    query_code: "consulta_generica_livre_paginada_filtrada",
    tabela: "minhas_inscricoes_view",
    termo_pesquisa: termo_pesquisa,
    campos_pesquisaveis: ["atletas" , "cod_inscricao_encurtado" , "status_pagamento"],
    
  };
  const celulas = [
    new ExibeItem("Atletas", "atletas"),
    new ExibeItem("Campeonato", "nome_campeonato"),
    new ExibeItem("cod_inscricao_encurtado", "cod_inscricao_encurtado"),
    new ExibeItem("Status", "status_pagamento"),

    
  ];

  //só precisa configurar acima disto
</script>
<div class="centralizar">
        
<Pesquisa bind:value={termo_pesquisa} {parametros} extraiDadosBasico={componente}  {termo_pesquisa} >

{#if $permissaoUsuario && $permissaoUsuario.permissoes.includes(Constantes.pode_ver_inscritos)}
<ExtraiDadosBasico bind:this = {componente} {api} {parametros} {celulas} navegacao={Constantes.tela_exibe_inscritos} />
{/if}

</Pesquisa>


</div>

<style>
  .centralizar {
      margin-top: 20px;
      margin-bottom: 100px;
   
    background-size: cover; /* Para cobrir toda a tela */
    background-position: center; /* Para centralizar a imagem */
  }
</style>
  